<template>
  <AppAlert color="info" icon="mdi:camera-outline" class="mb-3">
    {{ $t(`images_required_note_start_${country}`) }}
    <template v-if="types.includes('face') && types.includes('passport')">
      {{ $tt('images_required_note_face_pass') }}
    </template>
    <template v-else-if="types.includes('face')">
      {{ $tt('images_required_note_face') }}
    </template>
    <template v-else-if="types.includes('passport')">
      {{ $tt('images_required_note_pass') }}
    </template>
  </AppAlert>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import type { ApplicantPhotoType } from '~/types';

const country = inject(countryKeyInjectionKey);
defineProps<{
  types: ApplicantPhotoType[];
}>();
</script>